import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {
    KPIScorecard,
    ClientKPIScorecard,
    ClientKPIScorecardStaffPosition,
    IScorecardKPIInfo,
    IKPIScorecardChangeUpsertParams,
} from '../components/kpi-scorecard/kpi-scorecard-models';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class KpiScorecardService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/kpiscorecard').replace(
        '{version}',
        this.version
    );

    constructor(private http: HttpClient) {}

    getKPIScorecards(): Observable<KPIScorecard[]> {
        return this.http.get<KPIScorecard[]>(this._url + '/KPIScorecardSelect');
    }

    getClientKPIScorecards(): Observable<ClientKPIScorecard[]> {
        return this.http.get<ClientKPIScorecard[]>(this._url + '/ClientKPIScorecardSelect');
    }

    getClientKPIScorecardStaffPositions(): Observable<ClientKPIScorecardStaffPosition[]> {
        return this.http.get<ClientKPIScorecardStaffPosition[]>(
            this._url + '/ClientKPIScorecardStaffPositionSelect'
        );
    }

    upsertKPIScorecard(
        kpiScorecardKey: number,
        formValue: any,
        positionKeys: number[],
        clientKPIScorecardKey?: number
    ) {
        formValue.kpiScorecardKey = kpiScorecardKey;
        formValue.selectedPositions = positionKeys;
        return new Observable((subscriber) => {
            this.http.post<any>(this._url + '/UpsertClientKPIScorecard', formValue).subscribe(
                () => {
                    subscriber.next(true);
                },
                (response) => {
                    subscriber.error(response);
                }
            );
        });
    }

    upsertKPIScorecardProfileChanges(
        parameters: IKPIScorecardChangeUpsertParams[]
    ): Observable<number> {
        let params = {
            paramString: JSON.stringify(parameters),
        };
        return this.http.post<number>(this._url + '/ClientKPIScoreccardChangeUpsert/', params, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    getPossibleKPIsForScorecard(scorecard: string): Observable<IScorecardKPIInfo[]> {
        const params = new HttpParams().set('scorecard', scorecard);
        return this.http.get<IScorecardKPIInfo[]>(this._url + '/GetPossibleKPIsForScorecard', {
            params: params,
        });
    }
}
